/**
 * Frontend names for dark launched pilot flags, matching the keys in config/pilot.php.
 *
 * Export one constant per flag, e.g. `export const MY_FEATURE = "my-feature";`, and read it
 * w/ usePilotFlag() or a route's `meta.requiresPilotFlag`.
 */
export const HIRING_IQ = "hiring-iq";
